import { css } from '@repo/pandacss/styled-system/css';
import { type AnalyticsType } from '@repo/segment/types';
import { MonetizableEnum } from '@repo/supergraph/marketplace/enums';
import type { CtaType, ImageType } from '@repo/supergraph/marketplace/types';
import type { CSSProperties } from 'react';
import { CtaButton } from '../../../CtaButton';
import { NumericLayout } from '../../../StarRating/NumericLayout';
import { SingleStarLayout } from '../../../StarRating/SingleStarLayout';
import { CtaImage } from './CtaImage';
import { IMAGE_WIDTH_DESKTOP, IMAGE_WIDTH_MOBILE } from './constants';

type Props = {
  cta?: CtaType;
  ctaAnalytics: AnalyticsType;
  displayName?: string;
  image?: ImageType;
  monetizable?: MonetizableEnum;
  shouldApplyStylingUpdates?: boolean;
  starRating?: number;
  starRatingTooltip?: string;
  reviewLink?: string;
};

export const ImageCtaReviewSection = ({
  cta,
  ctaAnalytics,
  displayName,
  image,
  monetizable,
  shouldApplyStylingUpdates = false,
  starRating,
  starRatingTooltip,
  reviewLink,
}: Props) => {
  return (
    <div
      className={css({
        flexDirection: 'column',
        display: 'flex',
        marginRight: { base: '0', md: '12' },
      })}
    >
      <div
        className={css({ display: 'flex', marginBottom: '4' })}
        style={
          {
            '--cta-image-width-desktop': `${IMAGE_WIDTH_DESKTOP}px`,
            '--cta-image-width-mobile': `${IMAGE_WIDTH_MOBILE}px`,
          } as CSSProperties
        }
      >
        <div>
          <div
            className={css({
              width: {
                base: 'var(--cta-image-width-mobile)',
                md: 'var(--cta-image-width-desktop)',
              },
            })}
          >
            <CtaImage
              ctaAnalytics={ctaAnalytics}
              cta={cta}
              image={image}
              displayName={displayName}
              monetizable={monetizable}
            />
          </div>
          <div
            className={css({
              paddingTop: { base: '2', md: '4' },
              maxWidth: { base: '[unset]', md: 'var(--cta-image-width-desktop)' },
              textAlign: 'center',
              display: { base: 'none', md: 'block' },
            })}
          >
            <CtaButton
              analyticsPayload={ctaAnalytics}
              className={css({
                columnGap: '0',
                rowGap: '0',
              })}
              cta={cta}
            />
          </div>
        </div>
        <div className={css({ marginLeft: { base: '2', md: '7' } })}>
          {shouldApplyStylingUpdates ? (
            <SingleStarLayout
              starRating={starRating}
              starRatingTooltip={starRatingTooltip}
              reviewLink={reviewLink}
              displayLabel
            />
          ) : (
            <NumericLayout
              starRating={starRating}
              starRatingTooltip={starRatingTooltip}
              reviewLink={reviewLink}
              iconSize={20}
            />
          )}
        </div>
      </div>
      <div
        className={css({
          textAlign: 'center',
          display: { base: 'block', md: 'none' },
        })}
      >
        <CtaButton
          analyticsPayload={ctaAnalytics}
          buttonClassName={css({ height: '[45px]' })}
          className={css({
            columnGap: '0',
            rowGap: '0',
          })}
          cta={cta}
        />
      </div>
    </div>
  );
};
